import type { PointLog } from '@/shared/types';

export interface LeadStats {
  purchaseCount: number;
  redemptionCount: number;
  lifetimeSpent: number;
  yearSpent: number;
  avgTicket: number;
}

function isPurchase(log: PointLog): boolean {
  return log.action === 'addPoints' || log.action === 'input';
}

function isRedemption(log: PointLog): boolean {
  return log.action === 'resgate';
}

function countPurchases(logs: PointLog[]): number {
  const purchases = logs.filter(isPurchase);
  const hasRegistrationOnly = purchases.some((l) => l.action === 'input' && (l.price ?? 0) === 0);
  const count = purchases.length;
  return hasRegistrationOnly && count > 0 ? count - 1 : count;
}

function countRedemptions(logs: PointLog[]): number {
  return logs.filter(isRedemption).length;
}

function purchaseLogs(logs: PointLog[]): PointLog[] {
  return logs.filter((l) => l.action === 'addPoints' || (l.action === 'input' && (l.price ?? 0) > 0));
}

export function computeLeadStats(logs: PointLog[]): LeadStats {
  const purchaseCount = countPurchases(logs);
  const redemptionCount = countRedemptions(logs);
  const purchases = purchaseLogs(logs);
  const lifetimeSpent = purchases.reduce((acc, l) => acc + (l.price ?? 0), 0);
  const yearAgo = Date.now() - 365 * 24 * 60 * 60 * 1000;
  const yearSpent = purchases
    .filter((l) => new Date(l.date).getTime() >= yearAgo)
    .reduce((acc, l) => acc + (l.price ?? 0), 0);
  const avgTicket = purchaseCount > 0 ? lifetimeSpent / purchaseCount : 0;

  return { purchaseCount, redemptionCount, lifetimeSpent, yearSpent, avgTicket };
}
